import { useState, useCallback, createContext, useContext } from 'react';

const ConfirmModalContext = createContext(undefined);

export const ConfirmModalProvider = ({ children }) => {
  const [confirmModal, setConfirmModal] = useState({
    confirmText: '',
    isOpen: false,
    title: '',
    description: '',
    onConfirm: null,
    variant: 'default',
  });

  const showConfirmModal = useCallback(
    ({
      confirmText = '',
      description,
      onConfirm,
      title,
      variant = 'default',
    }) => {
      setConfirmModal({
        confirmText,
        description,
        isOpen: true,
        onConfirm,
        title,
        variant,
      });
    },
    []
  );

  const hideConfirmModal = useCallback(() => {
    setConfirmModal((prev) => ({
      ...prev,
      isOpen: false,
      onConfirm: null,
    }));
  }, []);

  return (
    <ConfirmModalContext.Provider
      value={{ confirmModal, showConfirmModal, hideConfirmModal }}
    >
      {children}
    </ConfirmModalContext.Provider>
  );
};

export const useConfirmModal = () => {
  const context = useContext(ConfirmModalContext);

  if (!context)
    throw new Error('useConfirmModal must be used within ConfirmModalProvider');

  return context;
};
